import { format } from "date-fns";
import { getExperienceDetails } from "@utils/experienceUtils";

export const getUniqueSessionDates = (sessions = []) => {
    return Array.from(
        new Set(
            sessions
                .filter((s) => s?.session_date && !isNaN(new Date(s.session_date)))
                .map((s) => format(new Date(s.session_date), "yyyy-MM-dd"))
        )
    ).sort((a, b) => new Date(a) - new Date(b));
};

export const filterSessionsByDateAndExperience = (sessions, date, experienceCodes) => {
    const hasExperienceFilter = Array.isArray(experienceCodes) && experienceCodes.length > 0;

    const normalizedExperiences = hasExperienceFilter
        ? experienceCodes.map((e) => e.toUpperCase())
        : [];

    return sessions.filter((session) => {
        const sessionDate = session.session_date?.slice(0, 10);
        const sessionType = session.session_type;
        const cinemaGroupId = session.cinema_group_id;

        const resolved = getExperienceDetails(session.ticket_class_id, {
            sessionType,
            cinemaGroupId,
        });

        if (!resolved?.short) return false;

        const matchesDate = !date || sessionDate === date;
        const matchesExperience = !hasExperienceFilter || normalizedExperiences.includes(resolved.short);
        return matchesDate && matchesExperience;
    });
};


export const groupSessionsByVenue = (sessions = []) => {
    const map = new Map();
    sessions.forEach((s) => {
        let g = map.get(s.venue_id);
        if (!g) {
            g = {
                venue_id: s.venue_id,
                venue_name: s.venue_name,
                venue_distance: +s.venue_distance || Infinity,
                venue_address: s.venue_address,
                venue_suburb: s.venue_suburb,
                venue_postcode: s.venue_postcode,
                venue_state: s.venue_state,
                sessions: [],
            };
            map.set(s.venue_id, g);
        }
        g.sessions.push(s);
    });
    return Array.from(map.values()).sort((a, b) => a.venue_distance - b.venue_distance);
};


